// Homepage bootstrap and loading bridge. Generated from the verified draft baseline.
(function () {
  var secondQuoteBootstrapScript =
      document.currentScript ||
      (function () {
        var scripts = document.getElementsByTagName("script");
        return scripts[scripts.length - 1] || null;
      })(),
    secondQuoteBootstrapAssetBase =
      secondQuoteBootstrapScript && secondQuoteBootstrapScript.src
        ? secondQuoteBootstrapScript.src.split("?")[0].replace(/\/[^\/]*$/, "/")
        : "",
    secondQuoteBootstrapHostedAssets = {
      "hero-sofa.png": "https://cdn.shopify.com/s/files/1/0739/1595/7442/files/hero-sofa.png?v=1790388588",
      "human-support-01.jpg": "https://cdn.shopify.com/s/files/1/0739/1595/7442/files/human-support-01.jpg?v=1790388439",
      "human-support-02.jpg": "https://cdn.shopify.com/s/files/1/0739/1595/7442/files/human-support-02.jpg?v=1790388471",
      "human-support-03.jpg": "https://cdn.shopify.com/s/files/1/0739/1595/7442/files/human-support-03.jpg?v=1790388465",
      "human-support-04.jpg": "https://cdn.shopify.com/s/files/1/0739/1595/7442/files/human-support-04.jpg?v=1790388489",
      "quote-modena-4-piece-chaise-transparent.png": "https://cdn.shopify.com/s/files/1/0739/1595/7442/files/quote-modena-4-piece-chaise-transparent.png?v=1790388479",
      "quote-york-slope-swivel-transparent.png": "https://cdn.shopify.com/s/files/1/0739/1595/7442/files/quote-york-slope-swivel-transparent.png?v=1790388498",
      "quote-rectangular-coffee-ottoman-leather-transparent.png": "https://cdn.shopify.com/s/files/1/0739/1595/7442/files/quote-rectangular-coffee-ottoman-leather-transparent.png?v=1790388507",
      "quote-reference-title-price.png": "https://cdn.shopify.com/s/files/1/0739/1595/7442/files/quote-reference-title-price.png?v=1790388515",
      "quote-reference-dimensions.png": "https://cdn.shopify.com/s/files/1/0739/1595/7442/files/quote-reference-dimensions.png?v=1790388521",
      "quote-reference-details.png": "https://cdn.shopify.com/s/files/1/0739/1595/7442/files/quote-reference-details.png?v=1790388527",
      "sq-home-material-wood.jpg": "https://cdn.shopify.com/s/files/1/0739/1595/7442/files/sq-home-material-wood.jpg?v=1790388533",
      "sq-home-material-fabric.jpg": "https://cdn.shopify.com/s/files/1/0739/1595/7442/files/sq-home-material-fabric.jpg?v=1790388539",
      "sq-home-material-leather.jpg": "https://cdn.shopify.com/s/files/1/0739/1595/7442/files/sq-home-material-leather.jpg?v=1790388543",
    };
  function secondQuoteBootstrapAssetUrl(path) {
    var value = String(path || "");
    if (!value || /^(?:[a-z][a-z0-9+.-]*:)?\/\//i.test(value) || /^(?:data|blob):/i.test(value)) return value;
    var normalized = value.replace(/^\.?\//, "");
    normalized.indexOf("assets/") === 0 && (normalized = normalized.slice(7));
    if (secondQuoteBootstrapHostedAssets[normalized]) return secondQuoteBootstrapHostedAssets[normalized];
    if (!secondQuoteBootstrapAssetBase) return value;
    try {
      return new URL(normalized, secondQuoteBootstrapAssetBase).toString();
    } catch (error) {
      return secondQuoteBootstrapAssetBase + normalized;
    }
  }
  function secondQuoteBootstrapNormalizePath(value) {
    var raw = String(value || "/").trim() || "/";
    try {
      /^(?:[a-z][a-z0-9+.-]*:)?\/\//i.test(raw) && (raw = new URL(raw, window.location.href).pathname || "/");
    } catch (error) {}
    return (
      (raw = raw.split("?")[0].split("#")[0] || "/"),
      raw.charAt(0) !== "/" && (raw = "/" + raw),
      (raw = raw.replace(/\/{2,}/g, "/")),
      raw.length > 1 && (raw = raw.replace(/\/+$/, "")),
      raw || "/"
    );
  }
  function secondQuoteBootstrapIsStorefrontHome() {
    try {
      if (new URLSearchParams(window.location.search).get("internal-check") === "1") return !1;
      var path = secondQuoteBootstrapNormalizePath(window.location.pathname || "/"),
        shopifyRoot = window.SECOND_QUOTE_SITE_ROOT_PATH || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/",
        rootPath = secondQuoteBootstrapNormalizePath(shopifyRoot || "/");
      return path === "/" || path === rootPath;
    } catch (error) {
      return !1;
    }
  }
  function secondQuoteBootstrapStorageJson(storage, key) {
    try {
      var raw = storage ? storage.getItem(key) : "";
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  }
  function secondQuoteBootstrapHomeExitPending() {
    var record = secondQuoteBootstrapStorageJson(window.sessionStorage, "second_quote_storefront_home_exit_v1");
    return !!(record && Number(record.saved_at) && Date.now() - Number(record.saved_at) <= 600 * 1e3);
  }
  function secondQuoteBootstrapConsentAccepted() {
    try {
      var storage = window.localStorage;
      if (!storage) return !1;
      for (var index = 0; index < storage.length; index += 1) {
        var key = storage.key(index) || "";
        if (key.indexOf("second_quote_consent_v1:") === 0) {
          var record = secondQuoteBootstrapStorageJson(storage, key);
          if (record && record.accepted === !0 && record.version === "privacy-use-20260725-v1") return !0;
        }
      }
    } catch (error) {}
    return !1;
  }
  function secondQuoteBootstrapSessionRecoveryKey() {
    var path = secondQuoteBootstrapNormalizePath(window.location && window.location.pathname ? window.location.pathname : "/");
    return "second_quote_session_recovery_v1:" + path;
  }
  function secondQuoteBootstrapSessionRecoveryCanonicalKey() {
    return "second_quote_session_recovery_v1:shared";
  }
  function secondQuoteBootstrapSessionRecoveryKeys() {
    var keys = [secondQuoteBootstrapSessionRecoveryKey(), secondQuoteBootstrapSessionRecoveryCanonicalKey()];
    try {
      var storage = window.sessionStorage;
      if (storage)
        for (var index = 0; index < storage.length; index += 1) {
          var key = storage.key(index) || "";
          key.indexOf("second_quote_session_recovery_v1:") === 0 && keys.indexOf(key) < 0 && keys.push(key);
        }
    } catch (error) {}
    return keys;
  }
  function secondQuoteBootstrapForceStorefrontHomeEntry() {
    secondQuoteBootstrapIsStorefrontHome() &&
      window.SECOND_QUOTE_ALLOW_STOREFRONT_HOME_DIRECT_CHAT !== !0 &&
      ((window.SECOND_QUOTE_ENTRY_VIEW = "home"), (window.SECOND_QUOTE_DIRECT_CHAT_ENTRY = !1), (window.SECOND_QUOTE_BOOTSTRAP_DIRECT_CHAT_ENTRY = !1));
  }
  function secondQuoteBootstrapLatestRecoveryRecord() {
    for (var best = null, keys = secondQuoteBootstrapSessionRecoveryKeys(), index = 0; index < keys.length; index += 1) {
      var record = secondQuoteBootstrapStorageJson(window.sessionStorage, keys[index]);
      if (!(!record || record.version !== "mobile-session-recovery-v1")) {
        var savedAt = Number(record.saved_at) || 0;
        !savedAt || Date.now() - savedAt > 720 * 60 * 1e3 || ((!best || savedAt > (Number(best.saved_at) || 0)) && (best = record));
      }
    }
    return best;
  }
  function secondQuoteBootstrapRecoveredView() {
    if (secondQuoteBootstrapHomeExitPending() || secondQuoteBootstrapIsStorefrontHome() || !secondQuoteBootstrapConsentAccepted()) return "home";
    var record = secondQuoteBootstrapLatestRecoveryRecord();
    if (!record || record.view !== "chat") return "home";
    var hasItems = Array.isArray(record.items) && record.items.length > 0,
      hasMessages = Array.isArray(record.messages) && record.messages.length > 0;
    return hasItems || hasMessages || record.awaiting_new_quote === !0 ? "chat" : "home";
  }
  function secondQuoteBootstrapDirectChatEntryRequested(mount2) {
    try {
      if (secondQuoteBootstrapIsStorefrontHome() && window.SECOND_QUOTE_ALLOW_STOREFRONT_HOME_DIRECT_CHAT !== !0)
        return (secondQuoteBootstrapForceStorefrontHomeEntry(), !1);
      var entryAttr = String((mount2 && mount2.getAttribute("data-second-quote-entry")) || "")
        .trim()
        .toLowerCase();
      return entryAttr === "chat" || entryAttr === "direct-chat" || window.SECOND_QUOTE_ENTRY_VIEW === "chat" || window.SECOND_QUOTE_DIRECT_CHAT_ENTRY === !0;
    } catch (error) {
      return !1;
    }
  }
  if (window.SECOND_QUOTE_PREVIEW_FRAME_HOST !== !0) {
    var mount = document.querySelector("[data-second-quote-ai-concierge-m1]"),
      initialSecondQuoteDirectChatEntry = !secondQuoteBootstrapIsStorefrontHome() && secondQuoteBootstrapDirectChatEntryRequested(mount);
    if ((initialSecondQuoteDirectChatEntry && (window.SECOND_QUOTE_BOOTSTRAP_DIRECT_CHAT_ENTRY = !0), secondQuoteBootstrapIsStorefrontHome() && !mount)) {
      window.SECOND_QUOTE_FRONTEND_DISABLED_REASON = "storefront-home";
      try {
        window.sessionStorage && window.sessionStorage.removeItem("second_quote_storefront_home_exit_v1");
      } catch (error) {}
      return;
    }
    var initialSecondQuoteView = initialSecondQuoteDirectChatEntry ? "chat" : secondQuoteBootstrapRecoveredView();
    (document.body.classList.add(initialSecondQuoteView === "chat" ? "is-chat" : "is-home"),
      mount || ((mount = document.createElement("div")), document.body.appendChild(mount)));
    var embedPlaceholder = document.createComment("second-quote-home-position");
    (mount.parentNode && mount.parentNode.insertBefore(embedPlaceholder, mount),
      mount.insertAdjacentHTML(
        "afterend",
        '<svg class="icon-sprite" aria-hidden="true" focusable="false">\n    <symbol id="sq-icon-camera" viewBox="0 0 20 20">\n      <path d="M9.99935 14.5833C11.041 14.5833 11.9264 14.2188 12.6556 13.4896C13.3848 12.7604 13.7493 11.875 13.7493 10.8333C13.7493 9.79167 13.3848 8.90625 12.6556 8.17708C11.9264 7.44792 11.041 7.08333 9.99935 7.08333C8.95768 7.08333 8.07227 7.44792 7.3431 8.17708C6.61393 8.90625 6.24935 9.79167 6.24935 10.8333C6.24935 11.875 6.61393 12.7604 7.3431 13.4896C8.07227 14.2188 8.95768 14.5833 9.99935 14.5833ZM3.33268 17.5C2.87435 17.5 2.48199 17.3368 2.1556 17.0104C1.82921 16.684 1.66602 16.2917 1.66602 15.8333V5.83333C1.66602 5.375 1.82921 4.98264 2.1556 4.65625C2.48199 4.32986 2.87435 4.16667 3.33268 4.16667H5.95768L6.99935 3.04167C7.15213 2.875 7.33615 2.74306 7.55143 2.64583C7.76671 2.54861 7.9924 2.5 8.22852 2.5H11.7702C12.0063 2.5 12.232 2.54861 12.4473 2.64583C12.6625 2.74306 12.8466 2.875 12.9993 3.04167L14.041 4.16667H16.666C17.1243 4.16667 17.5167 4.32986 17.8431 4.65625C18.1695 4.98264 18.3327 5.375 18.3327 5.83333V15.8333C18.3327 16.2917 18.1695 16.684 17.8431 17.0104C17.5167 17.3368 17.1243 17.5 16.666 17.5H3.33268Z" fill="currentColor"></path>\n    </symbol>\n    <symbol id="sq-icon-quick-prompts" viewBox="0 0 24 24">\n      <path clip-rule="evenodd" d="M21.75 18.75h-10.5l-6 4.5v-4.5h-3a1.5 1.5 0 0 1-1.5-1.5v-15a1.5 1.5 0 0 1 1.5-1.5h19.5a1.5 1.5 0 0 1 1.5 1.5v15a1.5 1.5 0 0 1-1.5 1.5Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>\n      <path d="M5.25 7.5h13.5M5.25 12h10.5" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>\n    </symbol>\n    <symbol id="sq-icon-send" viewBox="0 0 20 20">\n      <path d="M10 4.16602V15.666" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>\n      <path d="M5 8.33789L10 3.33789L15 8.33789" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>\n    </symbol>\n    <symbol id="sq-icon-panel-toggle" viewBox="0 0 28 20">\n      <rect x="4.5" y="3.5" width="19" height="13" rx="1.8" fill="none" stroke="currentColor" stroke-width="1.7"></rect>\n      <path d="M17.5 4.4v11.2" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"></path>\n    </symbol>\n    <symbol id="sq-icon-chevron-left" viewBox="0 0 20 20">\n      <path d="M12.4 4.6 7 10l5.4 5.4" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"></path>\n    </symbol>\n    <symbol id="sq-icon-plus" viewBox="0 0 20 20">\n      <path d="M10 4.5v11M4.5 10h11" fill="none" stroke="currentColor" stroke-width="1.85" stroke-linecap="round"></path>\n    </symbol>\n    <symbol id="sq-icon-link" viewBox="0 0 24 24">\n      <path d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1ZM8 13h8v-2H8v2Zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5Z" fill="currentColor"></path>\n    </symbol>\n    <symbol id="sq-icon-edit" viewBox="0 0 24 24">\n      <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25ZM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83Z" fill="currentColor"></path>\n    </symbol>\n    <symbol id="sq-icon-ruler" viewBox="0 0 24 24">\n      <path d="M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2Zm0 10H3V8h2v4h2V8h2v4h2V8h2v4h2V8h2v4h2V8h2v8Z" fill="currentColor"></path>\n    </symbol>\n  </svg>\n  <div class="sq-root">\n    <header class="sq-topbar">\n      <a class="sq-brand" href="#" data-action="home">\n        <span class="sq-mark">T</span>\n        <span class="sq-brand-copy">\n          <strong>Second Quote</strong>\n          <span>by TRUESTCO</span>\n        </span>\n      </a>\n      <nav class="sq-nav" aria-label="Preview controls">\n        <button type="button" data-action="signin">Sign in</button>\n      </nav>\n    </header>\n\n    <section class="home-view" aria-label="Second Quote start">\n      <div class="home-media" aria-hidden="true">\n        <video data-home-video muted loop playsinline preload="none">\n          <source data-legacy-video-disabled="true" type="video/mp4">\n        </video>\n      </div>\n      <div class="home-content">\n        <p class="eyebrow"><strong>Second Quote</strong> by TRUESTCO</p>\n        <h1 class="home-title">Love the piece. Second Quote it.</h1>\n        <p class="home-copy">Upload product page screenshots first, or paste the product link if that is easier. We will read the retail price, dimensions, material, and options before showing a transparent quote preview.</p>\n        <div class="home-dock">\n          <div class="composer-stack">\n            <form class="composer" data-composer="home">\n              <label class="sr-only" for="home-input">Describe your custom furniture project</label>\n              <div class="composer-attachments" data-staged-attachments="home" hidden></div>\n              <div class="quick-prompt-panel" data-quick-prompts-panel="home" hidden>\n                <span class="quick-prompt-grabber" aria-hidden="true"></span>\n                <strong class="quick-prompt-title" data-quick-prompts-title>Quick questions</strong>\n                <div class="quick-prompt-list" data-quick-prompts-list></div>\n              </div>\n              <div class="composer-main">\n                <div class="placeholder-overlay" data-placeholder="home"></div>\n                <div id="home-input" class="composer-editable" data-input="home" data-editable-input="home" contenteditable="plaintext-only" role="textbox" aria-label="Describe your custom furniture project" inputmode="text" spellcheck="true"></div>\n              </div>\n              <div class="composer-actions">\n                <div class="tool-row">\n                  <button class="tool-button media" type="button" data-action="upload" aria-label="Upload Product Page">\n                    <svg class="button-icon" aria-hidden="true"><use href="#sq-icon-camera"></use></svg>\n                    <span>Upload Product Page</span>\n                  </button>\n                </div>\n                <div class="send-row">\n                  <button class="icon-button quick-prompts-toggle" type="button" data-action="quick-prompts-toggle" data-quick-prompts-toggle="home" aria-label="Open quick questions" aria-expanded="false" title="Quick questions">\n                    <svg class="button-icon" aria-hidden="true"><use href="#sq-icon-quick-prompts"></use></svg>\n                  </button>\n                  <button class="send-button" type="submit" data-send="home" disabled aria-label="Send">\n                    <svg class="button-icon send-icon" aria-hidden="true"><use href="#sq-icon-send"></use></svg>\n                  </button>\n                </div>\n              </div>\n            </form>\n          </div>\n          <div class="proof-line" aria-label="Second Quote promise">\n            <span>Material transparency</span>\n            <span>Price transparency</span>\n            <span>Fixed 15% margin</span>\n          </div>\n        </div>\n      </div>\n    </section>\n\n    <section class="chat-view" aria-label="Second Quote AI chat">\n      <header class="mobile-chatbar" aria-label="Second Quote mobile navigation">\n        <button class="mobile-chatbar-button mobile-chatbar-back" type="button" data-action="mobile-back" aria-label="Back to Second Quote home">\n          <svg class="mobile-chatbar-icon" aria-hidden="true"><use href="#sq-icon-chevron-left"></use></svg>\n        </button>\n        <span class="mobile-chatbar-title">\n          <strong>Second Quote</strong>\n          <small class="sr-only" data-mobile-quote-summary aria-live="polite">No quote yet</small>\n        </span>\n        <span class="mobile-chatbar-actions">\n          <button class="mobile-chatbar-button mobile-chatbar-board" type="button" data-action="toggle-sidebar" data-mobile-board-toggle aria-label="Open quote board" aria-expanded="false">\n            <svg class="mobile-chatbar-icon" aria-hidden="true"><use href="#sq-icon-panel-toggle"></use></svg>\n            <span class="mobile-chatbar-count" data-mobile-quote-count hidden>0</span>\n          </button>\n          <button class="mobile-chatbar-button mobile-chatbar-new" type="button" data-action="reset" aria-label="Add another quote item">\n            <svg class="mobile-chatbar-icon" aria-hidden="true"><use href="#sq-icon-plus"></use></svg>\n          </button>\n        </span>\n      </header>\n      <div class="mobile-sidebar-scrim" data-action="close-mobile-sidebar" aria-hidden="true"></div>\n      <aside class="chat-sidebar" aria-label="Second Quote navigation">\n        <div class="sidebar-inner">\n          <button class="sidebar-new" type="button" data-action="reset">New quote</button>\n          <nav class="sidebar-nav" aria-label="Quote workspace">\n            <div class="sidebar-item-list" data-sidebar-items></div>\n          </nav>\n          <div class="sidebar-foot">\n            <button class="sidebar-signin" type="button" data-action="signin">Sign in</button>\n            <button class="sidebar-toggle" type="button" data-action="toggle-sidebar" data-sidebar-toggle aria-label="Collapse sidebar" aria-expanded="true" title="Collapse sidebar">\n              <svg aria-hidden="true"><use href="#sq-icon-panel-toggle"></use></svg>\n            </button>\n          </div>\n        </div>\n      </aside>\n      <div class="quote-sticky-shell" data-quote-sticky aria-hidden="true"></div>\n      <div class="thread-scroll" data-thread-scroll>\n        <main class="thread" data-thread></main>\n      </div>\n\n      <div class="composer-zone">\n        <div class="composer-stack" data-composer-stack>\n          <div data-workspace-panel></div>\n          <form class="composer" data-composer="chat">\n            <label class="sr-only" for="chat-input">Ask or continue your quote setup</label>\n            <div class="composer-attachments" data-staged-attachments="chat" hidden></div>\n            <div class="quick-prompt-panel" data-quick-prompts-panel="chat" hidden>\n              <span class="quick-prompt-grabber" aria-hidden="true"></span>\n              <strong class="quick-prompt-title" data-quick-prompts-title>Quick questions</strong>\n              <div class="quick-prompt-list" data-quick-prompts-list></div>\n            </div>\n            <div class="composer-main">\n              <div class="placeholder-overlay" data-placeholder="chat"></div>\n              <textarea id="chat-input" class="composer-native-input composer-multiline-input" data-input="chat" rows="1" wrap="soft" aria-label="Ask or continue your quote setup" inputmode="text" enterkeyhint="send" autocomplete="off" autocapitalize="sentences" spellcheck="true"></textarea>\n            </div>\n            <div class="composer-actions">\n              <div class="tool-row">\n                <button class="tool-button media" type="button" data-action="upload" aria-label="Upload Product Page">\n                  <svg class="button-icon" aria-hidden="true"><use href="#sq-icon-camera"></use></svg>\n                  <span>Upload Product Page</span>\n                </button>\n              </div>\n              <div class="send-row">\n                <button class="icon-button quick-prompts-toggle" type="button" data-action="quick-prompts-toggle" data-quick-prompts-toggle="chat" aria-label="Open quick questions" aria-expanded="false" title="Quick questions">\n                  <svg class="button-icon" aria-hidden="true"><use href="#sq-icon-quick-prompts"></use></svg>\n                </button>\n                <button class="send-button" type="submit" data-send="chat" disabled aria-label="Send">\n                  <svg class="button-icon send-icon" aria-hidden="true"><use href="#sq-icon-send"></use></svg>\n                </button>\n              </div>\n            </div>\n          </form>\n        </div>\n      </div>\n    </section>\n  </div>\n\n  <input class="sr-only" type="file" data-file-input accept="image/*" multiple>',
      ));
    var embedSprite = mount.nextElementSibling,
      embedRoot =
        embedSprite &&
        embedSprite.nextElementSibling &&
        embedSprite.nextElementSibling.classList &&
        embedSprite.nextElementSibling.classList.contains("sq-root")
          ? embedSprite.nextElementSibling
          : document.querySelector(".sq-root");
    function installFastLocalHome(root, sprite) {
      var home = root && root.querySelector ? root.querySelector(".home-view") : null;
      if (!home || home.getAttribute("data-sq-home-integrated") === "true") return;
      sprite &&
        sprite.insertAdjacentHTML(
          "beforeend",
          '<symbol id="sq-icon-photo" viewBox="0 0 24 24"><path d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></symbol><symbol id="sq-icon-info" viewBox="0 0 24 24"><path d="M11.25 11.25 12 10.5m-.75.75H12v4.5m9-3.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-4.125h.008v.008H12v-.008Z" fill="none" stroke="currentColor" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round"></path></symbol><symbol id="sq-icon-close" viewBox="0 0 24 24"><path d="M6 18 18 6M6 6l12 12" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path></symbol>',
        );
      home.setAttribute("data-sq-home-integrated", "true");
      home.innerHTML = `
        <main class="sq-home-page" data-homepage-version="fast-home-20260924-001">
          <section class="sq-home-hero" id="sq-home-top" aria-label="Second Quote introduction">
            <div class="sq-home-hero-image" aria-hidden="true">
              <video class="sq-home-hero-video" muted loop playsinline preload="none">
                <source data-legacy-video-disabled="true" type="video/mp4">
              </video>
            </div>

            <div class="sq-home-copy">
              <p class="sq-home-eyebrow">Second Quote by TRUESTCO</p>
              <h1><span>Love a piece of furniture?</span><span>See what a custom version could cost.</span></h1>
              <p class="sq-home-intro">Share product-page screenshots or a link. We work directly with partner factories to read the visible details and show a preliminary custom-production estimate with materials and costs broken down.</p>
              <span class="sq-home-intake-anchor" data-sq-home-intake-anchor aria-hidden="true"></span>
              <div class="sq-home-intake-wrap" data-sq-home-intake-wrap data-composer-mode="inline">
                <div class="composer-stack">
                  <form class="composer" data-composer="home" aria-label="Ask or share a product reference">
                    <label class="sr-only" for="home-input">Ask a question or paste a product link</label>
                    <div class="composer-attachments" data-staged-attachments="home" hidden></div>
                    <div class="quick-prompt-panel" data-quick-prompts-panel="home" hidden>
                      <span class="quick-prompt-grabber" aria-hidden="true"></span>
                      <strong class="quick-prompt-title" data-quick-prompts-title>Quick questions</strong>
                      <div class="quick-prompt-list" data-quick-prompts-list></div>
                    </div>
                    <div class="composer-main">
                      <div class="placeholder-overlay" data-placeholder="home"></div>
                      <div id="home-input" class="composer-editable" data-input="home" data-editable-input="home" contenteditable="plaintext-only" role="textbox" aria-label="Ask a question or paste a product link" inputmode="text" spellcheck="true"></div>
                    </div>
                    <div class="composer-actions">
                      <div class="tool-row">
                        <button class="tool-button media" type="button" data-action="upload" aria-label="Upload product-page screenshots" title="Upload product-page screenshots">
                          <svg class="button-icon" aria-hidden="true"><use href="#sq-icon-photo"></use></svg>
                          <span>Upload product-page screenshots</span>
                        </button>
                      </div>
                      <div class="send-row">
                        <button class="icon-button quick-prompts-toggle" type="button" data-action="quick-prompts-toggle" data-quick-prompts-toggle="home" aria-label="Open quick questions" aria-expanded="false" title="Quick questions">
                          <svg class="button-icon" aria-hidden="true"><use href="#sq-icon-quick-prompts"></use></svg>
                        </button>
                        <button class="send-button" type="submit" data-send="home" disabled aria-label="Send" title="Send">
                          <svg class="button-icon send-icon" aria-hidden="true"><use href="#sq-icon-send"></use></svg>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <p class="sq-home-signoff">Love the piece. Second Quote it.</p>
            </div>

            <aside class="sq-home-quote-card" data-sq-home-card aria-label="Second Quote comparison">
              <a class="sq-home-card-link" data-sq-home-card-link href="https://www.truestco.com/products/modena-slipcovered-modular-track-arm-4-piece-chaise-sectional" aria-label="View Modena Slipcovered Modular Track Arm 4-Piece Chaise Sectional on TRUESTCO">
                <div class="sq-home-card-header">
                  <span>Second Quote</span>
                  <span class="sq-home-card-cta">View details <svg aria-hidden="true"><use href="#sq-icon-chevron-left"></use></svg></span>
                </div>
                <div class="sq-home-card-main" data-sq-home-card-main>
                  <img data-sq-home-product-image src="${secondQuoteBootstrapAssetUrl("quote-modena-4-piece-chaise-transparent.png")}" alt="Modena Slipcovered Modular Track Arm 4-Piece Chaise Sectional">
                  <div class="sq-home-card-details">
                    <div class="sq-home-benchmark-brand" data-sq-home-brand>RH</div>
                    <div class="sq-home-benchmark-product" data-sq-home-product>Modena Slipcovered Modular Track Arm 4-Piece Chaise Sectional</div>
                    <div class="sq-home-saving-lockup"><strong data-sq-home-save>Save $4,411</strong><span data-sq-home-percent>43% lower</span></div>
                    <div class="sq-home-price-contrast">
                      <div><span aria-label="Original retail price">Original</span><del data-sq-home-retail>$10,340</del></div>
                      <div><span>Second Quote</span><strong data-sq-home-estimate>$5,929</strong></div>
                    </div>
                  </div>
                </div>
                <p class="sq-home-disclaimer"><span>Independence</span><span data-sq-home-disclaimer>Truestco is independent and is not affiliated with, sponsored by, or endorsed by RH.</span></p>
              </a>
              <div class="sq-home-carousel" aria-label="Example products">
                <button type="button" data-sq-home-prev aria-label="Previous example"><svg aria-hidden="true"><use href="#sq-icon-chevron-left"></use></svg></button>
                <div class="sq-home-carousel-dots">
                  <button type="button" class="is-active" data-sq-home-dot="0" aria-label="Show Modena sectional example" aria-current="true"></button>
                  <button type="button" data-sq-home-dot="1" aria-label="Show York swivel chair example"></button>
                  <button type="button" data-sq-home-dot="2" aria-label="Show leather coffee ottoman example"></button>
                </div>
                <button type="button" data-sq-home-next aria-label="Next example"><svg aria-hidden="true"><use href="#sq-icon-chevron-left"></use></svg></button>
              </div>
              <p class="sq-home-card-footnote"><svg aria-hidden="true"><use href="#sq-icon-info"></use></svg>Public listed price. Final specifications are human reviewed.</p>
            </aside>
          </section>

          <section class="sq-home-how" id="sq-home-how-it-works" aria-label="How it works">
            <h2 class="sq-home-how-title">How it works</h2>
            <div class="sq-home-steps">
              <article class="sq-home-step">
                <div class="sq-home-step-content">
                  <div class="sq-home-evidence sq-home-source-evidence" aria-label="Three product-page screenshots or one exact product-page link">
                    <div class="sq-home-screenshot-message">
                      <div class="sq-home-screenshot-stack" aria-label="Three product-page screenshots">
                        <figure role="button" tabindex="0" data-sq-home-reference data-src="${secondQuoteBootstrapAssetUrl("quote-reference-title-price.png")}" data-label="Title + price" data-alt="Product-page screenshot showing the product title, selected options and retail price" aria-label="View full title and price screenshot"><img src="${secondQuoteBootstrapAssetUrl("quote-reference-title-price.png")}" alt="Product-page screenshot showing the product title, selected options and retail price"><figcaption>Title + price</figcaption></figure>
                        <figure role="button" tabindex="0" data-sq-home-reference data-src="${secondQuoteBootstrapAssetUrl("quote-reference-dimensions.png")}" data-label="Dimensions" data-alt="Product-page screenshot showing overall dimensions" aria-label="View full dimensions screenshot"><img src="${secondQuoteBootstrapAssetUrl("quote-reference-dimensions.png")}" alt="Product-page screenshot showing overall dimensions"><figcaption>Dimensions</figcaption></figure>
                        <figure role="button" tabindex="0" data-sq-home-reference data-src="${secondQuoteBootstrapAssetUrl("quote-reference-details.png")}" data-label="Details" data-alt="Product-page screenshot showing construction and material details" aria-label="View full product details screenshot"><img src="${secondQuoteBootstrapAssetUrl("quote-reference-details.png")}" alt="Product-page screenshot showing construction and material details"><figcaption>Details</figcaption></figure>
                      </div>
                      <div class="sq-home-screenshot-count"><strong>3</strong><span>Screenshots</span></div>
                    </div>
                    <div class="sq-home-source-link"><span>OR</span><div><small>Paste above</small><strong>Exact product-page URL</strong></div></div>
                  </div>
                  <details class="sq-home-step-disclosure" data-sq-home-step-disclosure data-default-open open aria-expanded="true">
                    <summary class="sq-home-step-toggle">
                      <h3><span>01 / 03</span>Share the product you love</h3>
                      <span class="sq-home-animated-plus" aria-hidden="true"></span>
                    </summary>
                    <div class="sq-home-step-panel">
                      <ul class="sq-home-points">
                        <li><strong>Paste a product link</strong><span>Use the exact product page with your selected size, material and options. Expected quote time: about 30 seconds.</span></li>
                        <li><strong>Upload screenshots</strong><span>Include title + price, selected options, dimensions and product details. Any clear screenshots work. Expected quote time: about 60 seconds.</span></li>
                      </ul>
                    </div>
                  </details>
                </div>
              </article>

              <article class="sq-home-step">
                <div class="sq-home-step-content">
                  <div class="sq-home-evidence sq-home-quote-evidence" aria-label="Second Quote price and material transparency">
                    <div class="sq-home-transparency-visuals">
                      <div class="sq-home-transparency-visual sq-home-price-visual">
                        <div class="sq-home-visual-body">
                          <div class="sq-cost-ring-wrap sq-home-cost-ring-wrap" aria-label="Full landed cost breakdown">
                            <div class="sq-cost-ring" style="background: conic-gradient(from 0deg, var(--sq-calc-primary, #38BDF8) 0deg 118.8deg, var(--sq-calc-accent, #A78BFA) 118.8deg 194.4deg, var(--sq-calc-warning, #FBBF24) 194.4deg 230.4deg, var(--sq-calc-success, #34D399) 230.4deg 255.6deg, var(--sq-calc-acquisition, #FB923C) 255.6deg 306deg, var(--sq-calc-profit, #F472B6) 306deg 360deg)" aria-hidden="true"></div>
                            <div class="sq-cost-ring-center"><strong>100%</strong><span>Total cost</span></div>
                          </div>
                        </div>
                      </div>
                      <div class="sq-home-transparency-visual sq-home-material-visual">
                        <div class="sq-home-visual-body">
                          <div class="sq-home-material-stack" aria-label="Wood, fabric and leather material references">
                            <img src="${secondQuoteBootstrapAssetUrl("sq-home-material-wood.jpg")}" alt="Wood finish samples">
                            <img src="${secondQuoteBootstrapAssetUrl("sq-home-material-fabric.jpg")}" alt="Upholstery fabric samples">
                            <img src="${secondQuoteBootstrapAssetUrl("sq-home-material-leather.jpg")}" alt="Leather samples">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="sq-home-result-bar">
                      <div class="sq-home-result-primary"><span>Second Quote</span><strong>$8,593</strong></div>
                      <div><span>Original</span><strong>$14,295</strong></div>
                      <div><span>You save</span><strong>$5,702</strong></div>
                      <div class="sq-home-saving-rate"><span>Saving</span><strong>40%</strong></div>
                    </div>
                  </div>
                  <details class="sq-home-step-disclosure" data-sq-home-step-disclosure open aria-expanded="true">
                    <summary class="sq-home-step-toggle">
                      <h3><span>02 / 03</span>Review your Second Quote</h3>
                      <span class="sq-home-animated-plus" aria-hidden="true"></span>
                    </summary>
                    <div class="sq-home-step-panel">
                      <ul class="sq-home-points">
                        <li><strong>Your quote</strong><span>Delivered-price estimate, retail comparison, savings amount and saving percentage.</span></li>
                        <li><strong>Price transparency</strong><span>Factory EXW, logistics, duties &amp; fees, operations, marketing &amp; after-sales, and TRUESTCO profit.</span></li>
                        <li><strong>Material transparency</strong><span>Size, frame, upholstery, cushion &amp; fill, suspension, seat depth and cover type—with detected, proposed and to-confirm states.</span></li>
                      </ul>
                    </div>
                  </details>
                </div>
              </article>

              <article class="sq-home-step">
                <div class="sq-home-step-content">
                  <div class="sq-home-evidence sq-home-human-evidence" aria-label="Human support team">
                    <div class="sq-home-portraits" aria-hidden="true">
                      <img src="${secondQuoteBootstrapAssetUrl("human-support-01.jpg")}" alt="" draggable="false"><img src="${secondQuoteBootstrapAssetUrl("human-support-02.jpg")}" alt="" draggable="false"><img src="${secondQuoteBootstrapAssetUrl("human-support-03.jpg")}" alt="" draggable="false"><img src="${secondQuoteBootstrapAssetUrl("human-support-04.jpg")}" alt="" draggable="false">
                    </div>
                    <div class="sq-home-human-copy"><strong>Human support team</strong><span>Quote · specifications · production</span></div>
                  </div>
                  <details class="sq-home-step-disclosure" data-sq-home-step-disclosure open aria-expanded="true">
                    <summary class="sq-home-step-toggle">
                      <h3><span>03 / 03</span>Continue when you're ready</h3>
                      <span class="sq-home-animated-plus" aria-hidden="true"></span>
                    </summary>
                    <div class="sq-home-step-panel">
                      <ul class="sq-home-points">
                        <li><strong>No obligation</strong><span>Review the quote first. Continue only if it works for you.</span></li>
                        <li><strong>$99 production deposit</strong><span>If you are satisfied, pay the deposit to activate the human-led production process.</span></li>
                        <li><strong>Human-led production</strong><span>Our team confirms final specifications, materials, price, packaging and delivery assumptions with you before production begins.</span></li>
                      </ul>
                    </div>
                  </details>
                </div>
              </article>
            </div>
          </section>

          <div class="sq-home-lightbox" data-sq-home-lightbox role="dialog" aria-modal="true" aria-label="Product-page screenshot preview" hidden>
            <button type="button" class="sq-home-lightbox-close" data-sq-home-lightbox-close aria-label="Close screenshot preview"><svg aria-hidden="true"><use href="#sq-icon-close"></use></svg></button>
            <figure><img data-sq-home-lightbox-image src="" alt=""><figcaption data-sq-home-lightbox-caption></figcaption></figure>
          </div>
        </main>`;

      var examples = [
        {
          name: "Modena sectional",
          image: secondQuoteBootstrapAssetUrl("quote-modena-4-piece-chaise-transparent.png"),
          benchmarkBrand: "RH",
          benchmarkProduct: "Modena Slipcovered Modular Track Arm 4-Piece Chaise Sectional",
          truestcoProduct: "Modena Slipcovered Modular Track Arm 4-Piece Chaise Sectional",
          href: "https://www.truestco.com/products/modena-slipcovered-modular-track-arm-4-piece-chaise-sectional",
          retail: 10340,
          estimate: 5929,
        },
        {
          name: "York swivel chair",
          image: secondQuoteBootstrapAssetUrl("quote-york-slope-swivel-transparent.png"),
          benchmarkBrand: "Pottery Barn",
          benchmarkProduct: "York Slope Arm Slipcovered Swivel Chair",
          truestcoProduct: "York Slope Swivel Chair · Performance Linen Weave Pure White",
          href: "https://www.truestco.com/products/lounge-chairs_york-slope-swivel-linen-weave-pure-white",
          retail: 2399,
          estimate: 1922,
        },
        {
          name: "Leather coffee ottoman",
          image: secondQuoteBootstrapAssetUrl("quote-rectangular-coffee-ottoman-leather-transparent.png"),
          benchmarkBrand: "RH",
          benchmarkProduct: "Thaddeus Leather Rectangular Coffee Ottoman",
          truestcoProduct: "Rectangular Coffee Ottoman, Leather",
          href: "https://www.truestco.com/products/rectangular-coffee-ottoman-leather",
          retail: 8640,
          estimate: 3994,
        },
      ];
      var slide = 0,
        card = home.querySelector("[data-sq-home-card]"),
        cardMain = home.querySelector("[data-sq-home-card-main]"),
        slideTimer = 0,
        slideBusy = !1;
      function money(value) {
        return "$" + Number(value || 0).toLocaleString("en-US");
      }
      function renderHomeSlide(index, immediate) {
        if (slideBusy && !immediate) return;
        var next = (Number(index) + examples.length) % examples.length,
          item = examples[next],
          update = function () {
            slide = next;
            var link = home.querySelector("[data-sq-home-card-link]"),
              image = home.querySelector("[data-sq-home-product-image]");
            link.setAttribute("href", item.href);
            link.setAttribute("aria-label", "View " + item.truestcoProduct + " on TRUESTCO");
            image.setAttribute("src", item.image);
            image.setAttribute("alt", item.truestcoProduct);
            home.querySelector("[data-sq-home-brand]").textContent = item.benchmarkBrand;
            home.querySelector("[data-sq-home-product]").textContent = item.benchmarkProduct;
            home.querySelector("[data-sq-home-save]").textContent = "Save " + money(item.retail - item.estimate);
            home.querySelector("[data-sq-home-percent]").textContent = Math.round((1 - item.estimate / item.retail) * 100) + "% lower";
            home.querySelector("[data-sq-home-retail]").textContent = money(item.retail);
            home.querySelector("[data-sq-home-estimate]").textContent = money(item.estimate);
            home.querySelector("[data-sq-home-disclaimer]").textContent = "Truestco is independent and is not affiliated with, sponsored by, or endorsed by " + item.benchmarkBrand + ".";
            home.querySelectorAll("[data-sq-home-dot]").forEach(function (dot) {
              var active = Number(dot.getAttribute("data-sq-home-dot")) === slide;
              dot.classList.toggle("is-active", active);
              active ? dot.setAttribute("aria-current", "true") : dot.removeAttribute("aria-current");
            });
          };
        if (immediate || !cardMain || !cardMain.animate) {
          update();
          return;
        }
        slideBusy = !0;
        cardMain
          .animate([{ opacity: 1 }, { opacity: 0 }], { duration: 180, easing: "cubic-bezier(.4,0,1,1)", fill: "forwards" })
          .finished.then(function () {
            update();
            return cardMain.animate(
              [
                { opacity: 0, transform: "translate3d(4px,0,0)" },
                { opacity: 1, transform: "translate3d(0,0,0)" },
              ],
              { duration: 360, easing: "cubic-bezier(.22,1,.36,1)", fill: "both" },
            ).finished;
          })
          .catch(function () {
            update();
          })
          .finally(function () {
            slideBusy = !1;
          });
      }
      function restartSlideTimer() {
        window.clearInterval(slideTimer);
        slideTimer = window.setInterval(function () {
          renderHomeSlide(slide + 1, !1);
        }, 6500);
      }
      home.querySelector("[data-sq-home-prev]").addEventListener("click", function () {
        renderHomeSlide(slide - 1, !1);
        restartSlideTimer();
      });
      home.querySelector("[data-sq-home-next]").addEventListener("click", function () {
        renderHomeSlide(slide + 1, !1);
        restartSlideTimer();
      });
      home.querySelectorAll("[data-sq-home-dot]").forEach(function (dot) {
        dot.addEventListener("click", function () {
          renderHomeSlide(Number(dot.getAttribute("data-sq-home-dot")), !1);
          restartSlideTimer();
        });
      });
      card.addEventListener("mouseenter", function () {
        window.clearInterval(slideTimer);
      });
      card.addEventListener("mouseleave", restartSlideTimer);
      card.addEventListener("focusin", function () {
        window.clearInterval(slideTimer);
      });
      card.addEventListener("focusout", restartSlideTimer);
      restartSlideTimer();

      var lightbox = home.querySelector("[data-sq-home-lightbox]"),
        lightboxImage = home.querySelector("[data-sq-home-lightbox-image]"),
        lightboxCaption = home.querySelector("[data-sq-home-lightbox-caption]");
      function closeHomeLightbox() {
        if (!lightbox || lightbox.hidden) return;
        lightbox.hidden = !0;
        document.body.classList.remove("sq-home-lightbox-open");
      }
      function openHomeLightbox(reference) {
        lightboxImage.setAttribute("src", reference.getAttribute("data-src") || "");
        lightboxImage.setAttribute("alt", reference.getAttribute("data-alt") || "");
        lightboxCaption.textContent = reference.getAttribute("data-label") || "Product-page screenshot";
        lightbox.hidden = !1;
        document.body.classList.add("sq-home-lightbox-open");
        home.querySelector("[data-sq-home-lightbox-close]").focus();
      }
      home.querySelectorAll("[data-sq-home-reference]").forEach(function (reference) {
        reference.addEventListener("click", function () {
          openHomeLightbox(reference);
        });
        reference.addEventListener("keydown", function (event) {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            openHomeLightbox(reference);
          }
        });
      });
      home.querySelector("[data-sq-home-lightbox-close]").addEventListener("click", closeHomeLightbox);
      lightbox.addEventListener("click", function (event) {
        event.target === lightbox && closeHomeLightbox();
      });
      document.addEventListener("keydown", function (event) {
        event.key === "Escape" && closeHomeLightbox();
      });

      var intakeAnchor = home.querySelector("[data-sq-home-intake-anchor]"),
        intakeWrap = home.querySelector("[data-sq-home-intake-wrap]"),
        howSection = home.querySelector("#sq-home-how-it-works"),
        mobileQuery = window.matchMedia("(max-width: 620px)"),
        reducedMotionQuery = window.matchMedia("(prefers-reduced-motion: reduce)"),
        homeStepDisclosures = Array.prototype.slice.call(home.querySelectorAll("[data-sq-home-step-disclosure]")),
        homeStepViewportMobile = null,
        dockFrame = 0;
      function finishHomeStepDisclosure(details, opening, animationToken) {
        if (animationToken && details.getAttribute("data-animation-token") !== animationToken) return;
        details.open = opening;
        details.setAttribute("aria-expanded", opening ? "true" : "false");
        details.removeAttribute("data-animating");
        details.removeAttribute("data-animation-token");
        details.style.removeProperty("height");
        details.style.removeProperty("overflow");
        syncHomeComposerDock();
      }
      function animateHomeStepDisclosure(details) {
        if (details.hasAttribute("data-animating")) return;
        var summary = details.querySelector(".sq-home-step-toggle"),
          panel = details.querySelector(".sq-home-step-panel"),
          opening = !details.open;
        if (!summary || !panel || reducedMotionQuery.matches || !details.animate || !panel.animate) {
          finishHomeStepDisclosure(details, opening);
          return;
        }
        var animationToken = String(Date.now()) + String(Math.random());
        details.setAttribute("data-animating", "true");
        details.setAttribute("data-animation-token", animationToken);
        var collapsedHeight = summary.getBoundingClientRect().height + 2,
          startHeight,
          endHeight;
        if (opening) {
          details.open = !0;
          details.setAttribute("aria-expanded", "true");
          startHeight = collapsedHeight;
          endHeight = details.getBoundingClientRect().height;
        } else {
          startHeight = details.getBoundingClientRect().height;
          endHeight = collapsedHeight;
        }
        details.style.overflow = "hidden";
        var heightAnimation = details.animate(
            [{ height: startHeight + "px" }, { height: endHeight + "px" }],
            { duration: 250, easing: "ease-in-out" },
          ),
          panelAnimation = panel.animate(
            opening
              ? [
                  { opacity: 0, transform: "translateY(4px)" },
                  { opacity: 1, transform: "translateY(0)" },
                ]
              : [{ opacity: 1 }, { opacity: 0 }],
            { duration: 150, easing: "ease-in-out", fill: "both" },
          );
        Promise.all([heightAnimation.finished, panelAnimation.finished])
          .then(function () {
            finishHomeStepDisclosure(details, opening, animationToken);
          })
          .catch(function () {
            finishHomeStepDisclosure(details, opening, animationToken);
          });
      }
      function syncHomeStepDisclosures() {
        var isMobile = mobileQuery.matches;
        if (homeStepViewportMobile === isMobile) return;
        homeStepViewportMobile = isMobile;
        homeStepDisclosures.forEach(function (details) {
          details.removeAttribute("data-animation-token");
          details.getAnimations().forEach(function (animation) {
            animation.cancel();
          });
          details.querySelectorAll(".sq-home-step-panel").forEach(function (panel) {
            panel.getAnimations().forEach(function (animation) {
              animation.cancel();
            });
          });
          details.removeAttribute("data-animating");
          details.style.removeProperty("height");
          details.style.removeProperty("overflow");
          var summary = details.querySelector(".sq-home-step-toggle"),
            shouldOpen = !isMobile || details.hasAttribute("data-default-open");
          details.open = shouldOpen;
          details.setAttribute("aria-expanded", shouldOpen ? "true" : "false");
          summary && (isMobile ? summary.removeAttribute("tabindex") : summary.setAttribute("tabindex", "-1"));
        });
      }
      homeStepDisclosures.forEach(function (details) {
        var summary = details.querySelector(".sq-home-step-toggle");
        summary &&
          summary.addEventListener("click", function (event) {
            event.preventDefault();
            if (!mobileQuery.matches) {
              details.open = !0;
              details.setAttribute("aria-expanded", "true");
              return;
            }
            animateHomeStepDisclosure(details);
          });
      });
      function closeHiddenHomeQuickPrompts() {
        var panel = home.querySelector('[data-quick-prompts-panel="home"]'),
          toggle = home.querySelector('[data-quick-prompts-toggle="home"]'),
          form = panel && panel.closest("[data-composer]");
        if (!panel || (panel.hidden && (!toggle || toggle.getAttribute("aria-expanded") !== "true"))) return;
        document.dispatchEvent(new CustomEvent("second-quote:home-composer-hidden"));
        panel.hidden = !0;
        panel.classList.remove("is-open", "is-leaving");
        form && form.classList.remove("is-quick-prompts-open", "is-quick-prompts-closing");
        if (toggle) {
          toggle.setAttribute("aria-expanded", "false");
          toggle.classList.remove("is-active");
        }
      }
      function syncHomeComposerDock() {
        window.cancelAnimationFrame(dockFrame);
        dockFrame = window.requestAnimationFrame(function () {
          var mode = "inline",
            previousMode = intakeWrap.getAttribute("data-composer-mode") || "inline";
          if (mobileQuery.matches && document.body.classList.contains("is-home")) {
            var anchorTop = intakeAnchor.getBoundingClientRect().top,
              height = intakeWrap.offsetHeight,
              howBottom = howSection.getBoundingClientRect().bottom,
              dockBottom = Number.parseFloat(window.getComputedStyle(intakeWrap).bottom) || 0,
              howBoundary = window.innerHeight - dockBottom;
            mode = anchorTop + height <= 0 ? (howBottom > howBoundary ? "docked" : "hidden") : "inline";
          }
          mode === "hidden" && previousMode !== "hidden" && closeHiddenHomeQuickPrompts();
          intakeWrap.setAttribute("data-composer-mode", mode);
          intakeWrap.classList.toggle("is-docked", mode === "docked");
          intakeWrap.classList.toggle("is-hidden", mode === "hidden");
        });
      }
      window.addEventListener("scroll", syncHomeComposerDock, { passive: !0 });
      window.addEventListener("resize", syncHomeComposerDock);
      mobileQuery.addEventListener &&
        mobileQuery.addEventListener("change", function () {
          syncHomeStepDisclosures();
          syncHomeComposerDock();
        });
      syncHomeStepDisclosures();
      syncHomeComposerDock();
    }
    installFastLocalHome(embedRoot, embedSprite);
    var existingPoster = mount.querySelector('[data-sq-initial-poster]');
    var heroMedia = embedRoot.querySelector('.sq-home-hero-image');
    if (existingPoster && heroMedia) {
      existingPoster.className = 'sq-split-poster';
      heroMedia.appendChild(existingPoster);
    }
    ((window.SECOND_QUOTE_EMBED = { placeholder: embedPlaceholder, sprite: embedSprite, root: embedRoot }), mount.remove());
  }
})();

(function () {
  'use strict';
  if (window.SecondQuoteSplit) return;
  const config = window.SECOND_QUOTE_SPLIT_CONFIG || {};
  const questions = ["What is Second Quote?","How is this different from traditional custom furniture?","Do I need professional drawings to start?","Can you match the original design closely?","Are you quoting the same quality level?","Will custom production cost more than the original?","What should I upload to get a quote?","How long does custom furniture usually take?"];
  const homeInput = document.querySelector('[data-input="home"]');
  const fileInput = document.querySelector('[data-file-input]');
  const root = document.querySelector('.sq-root');
  if (!root) return;
  let api = null;
  let loading = false;
  let loadElement = null;
  let pending = [];
  let questionOpen = false;
  let busyIntent = false;
  let fileScope = 'home';
  let filePickerPending = false;
  const listeners = [];
  const status = document.createElement('div');
  status.className = 'sq-split-status';
  status.setAttribute('role', 'status');
  status.setAttribute('aria-live', 'polite');
  status.hidden = true;
  (root.querySelector('.sq-home-intake-wrap') || root).appendChild(status);
  const bridge = window.SecondQuoteSplit = {
    ready: false,
    touched: false,
    status: 'idle',
    attach: attach,
    ensure: ensure,
  };
  function value(input) { return input ? ('value' in input ? input.value : input.textContent) || '' : ''; }
  function listen(target, name, handler, options = true) {
    target.addEventListener(name, handler, options);
    listeners.push(() => target.removeEventListener(name, handler, options));
  }
  function announce(text, retry) {
    status.replaceChildren(document.createTextNode(text));
    status.hidden = !text;
    if (retry) {
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = 'Try again';
      button.addEventListener('click', () => ensure(true), { once: true });
      status.appendChild(button);
    }
  }
  function ensure(urgent) {
    if (bridge.ready || api) return;
    if (loading) {
      if (urgent && loadElement) loadElement.fetchPriority = 'high';
      return;
    }
    loading = true;
    bridge.status = 'loading';
    loadElement = document.createElement('script');
    loadElement.src = config.workspaceUrl;
    loadElement.async = true;
    loadElement.fetchPriority = urgent ? 'high' : 'low';
    loadElement.onerror = function () {
      loading = false;
      bridge.status = 'failed';
      loadElement.remove();
      announce('Your input is kept. Could not open Second Quote. ', true);
    };
    loadElement.onload = function () {
      if (!api) {
        bridge.status = 'failed';
        announce('Your input is kept. Second Quote could not start. Please reload to try again.', false);
      }
    };
    document.head.appendChild(loadElement);
  }
  function enqueue(action) {
    bridge.touched = true;
    if (action.kind !== 'files' && busyIntent) return;
    if (action.kind !== 'files') busyIntent = true;
    pending.push(action);
    announce('Opening Second Quote…', false);
    ensure(true);
  }
  function refresh() {
    const send = root.querySelector('[data-send="home"]');
    const hasFiles = pending.some(action => action.kind === 'files');
    const canSend = Boolean(value(homeInput).trim() || hasFiles);
    if (send) {
      send.disabled = !canSend;
      send.setAttribute('aria-disabled', String(!canSend));
    }
    const placeholder = root.querySelector('[data-placeholder="home"]');
    if (placeholder) placeholder.hidden = Boolean(value(homeInput));
  }
  function toggleQuestions() {
    questionOpen = !questionOpen;
    const panel = root.querySelector('[data-quick-prompts-panel="home"]');
    const list = panel?.querySelector('[data-quick-prompts-list]');
    const toggle = root.querySelector('[data-quick-prompts-toggle="home"]');
    if (!panel || !list) return;
    if (!list.children.length) {
      questions.forEach((text, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'quick-prompt-option';
        button.dataset.action = 'quick-prompt-send';
        button.dataset.quickPromptIndex = String(index);
        const label = document.createElement('span');
        label.className = 'quick-prompt-text';
        label.textContent = text;
        button.appendChild(label);
        const arrow = document.createElement('span');
        arrow.className = 'quick-prompt-arrow';
        arrow.setAttribute('aria-hidden', 'true');
        arrow.innerHTML = '<svg viewBox="0 0 18 18" focusable="false"><path d="M6.8 4.6 11.2 9l-4.4 4.4"></path></svg>';
        button.appendChild(arrow);
        list.appendChild(button);
      });
    }
    panel.hidden = !questionOpen;
    panel.classList.toggle('is-open', questionOpen);
    panel.classList.toggle('is-entering', questionOpen);
    panel.closest('form')?.classList.toggle('is-quick-prompts-open', questionOpen);
    toggle?.setAttribute('aria-expanded', String(questionOpen));
    ensure(true);
  }
  function stop(event) { event.preventDefault(); event.stopImmediatePropagation(); }
  listen(document, 'click', function (event) {
    if (bridge.ready || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
    const target = event.target.closest?.('[data-action], [data-send], a[href]');
    if (!target) return;
    const link = target.closest('a[href]');
    if (link && !link.closest('.sq-root') && (!link.target || link.target === '_self')) {
      const url = new URL(link.href, location.href);
      if (url.origin === location.origin && /\/pages\/second-quote\/?$/.test(url.pathname)) {
        stop(event);
        const drawer = link.closest('header-sidebar');
        if (drawer && typeof drawer.hide === 'function') drawer.hide();
        enqueue({ kind: 'navigation' });
        return;
      }
    }
    if (!root.contains(target)) return;
    const action = target.dataset.action;
    if (target.hasAttribute('data-send')) {
      stop(event);
      if (value(homeInput).trim() || pending.some(item => item.kind === 'files')) enqueue({ kind: 'submit', text: value(homeInput), scope: 'home' });
    } else if (action === 'quick-prompts-toggle' || action === 'quick-prompts') {
      stop(event); toggleQuestions();
    } else if (action === 'quick-prompt-send') {
      stop(event); enqueue({ kind: 'quick', text: questions[Number(target.dataset.quickPromptIndex)], scope: 'home' });
    } else if (action === 'upload') {
      stop(event);
      fileScope = target.closest('[data-composer]')?.dataset.composer || 'home';
      filePickerPending = true;
      fileInput.value = '';
      fileInput.removeAttribute('capture');
      fileInput.click();
      ensure(true);
    }
  });
  listen(document, 'submit', function (event) {
    const form = event.target.closest?.('[data-composer]');
    if (!form || bridge.ready) return;
    stop(event);
    enqueue({ kind: 'submit', text: value(form.querySelector('[data-input]')), scope: form.dataset.composer });
  });
  listen(document, 'keydown', function (event) {
    if (event.target !== homeInput || bridge.ready || event.key !== 'Enter' || event.shiftKey || event.isComposing || event.keyCode === 229) return;
    stop(event);
    if (value(homeInput).trim() || pending.some(item => item.kind === 'files')) enqueue({ kind: 'submit', text: value(homeInput), scope: 'home' });
  });
  listen(document, 'input', function (event) {
    if (event.target === homeInput && !bridge.ready) { bridge.touched = true; refresh(); ensure(true); }
  });
  listen(document, 'paste', function (event) {
    if (event.target !== homeInput || bridge.ready) return;
    const files = Array.from(event.clipboardData?.files || []);
    if (files.length) { stop(event); enqueue({ kind: 'files', files, scope: 'home' }); refresh(); }
  });
  listen(fileInput, 'change', function (event) {
    if (bridge.ready) return;
    event.stopImmediatePropagation();
    const files = Array.from(fileInput.files || []);
    filePickerPending = false;
    if (files.length) { enqueue({ kind: 'files', files, scope: fileScope }); refresh(); }
  });
  listen(document, 'focusin', function (event) {
    if (root.contains(event.target)) { bridge.touched = true; ensure(true); }
  });
  listen(window, 'scroll', function () { bridge.touched = true; }, { passive: true });
  async function attach(workspace) {
    api = workspace;
    bridge.status = 'initializing';
    if (filePickerPending) api.primeUpload(fileScope);
    api.refresh();
    if (questionOpen && !busyIntent) api.openQuestions(true);
    try {
      while (pending.length) {
        const action = pending.shift();
        if (action.kind === 'files') await api.stageFiles(action.files, action.scope);
        if (action.kind === 'submit') api.submit(action.scope, action.text);
        if (action.kind === 'quick') api.quick(action.text, action.scope);
        if (action.kind === 'navigation') api.openNavigation();
      }
      announce('', false);
    } catch (_) {
      announce('Could not complete the action. Please try again.', false);
    } finally {
      bridge.ready = true;
      bridge.status = 'ready';
      listeners.forEach(remove => remove());
      busyIntent = false;
    }
    document.dispatchEvent(new CustomEvent('second-quote:workspace-ready'));
  }
  refresh();
  const poster = root.querySelector('[data-sq-initial-poster] img, img[data-sq-initial-poster]');
  const video = root.querySelector('.sq-home-hero-video');
  const mobile = matchMedia('(max-width: 767px)');
  function playVideo() {
    if (!video || matchMedia('(prefers-reduced-motion: reduce)').matches || navigator.connection?.saveData) return;
    video.muted = true;
    video.defaultMuted = true;
    const src = mobile.matches ? config.mobileVideo : config.desktopVideo;
    if (src && video.getAttribute('src') !== src) { video.src = src; video.load(); }
    video.play().catch(() => {});
  }
  mobile.addEventListener('change', playVideo);
  function afterPoster() {
    requestAnimationFrame(() => requestAnimationFrame(() => {
      ensure(false);
      playVideo();
    }));
  }
  if (video) video.addEventListener('playing', () => {
    const picture = root.querySelector('[data-sq-initial-poster]');
    if (picture) picture.classList.add('sq-split-poster--playing');
  });
  const direct = window.SECOND_QUOTE_DIRECT_CHAT_ENTRY || window.SECOND_QUOTE_ENTRY_VIEW === 'chat' || /\/pages\/second-quote\/?$/.test(location.pathname);
  if (direct) { ensure(true); afterPoster(); }
  else if (!poster || poster.complete) afterPoster();
  else { poster.addEventListener('load', afterPoster, { once: true }); poster.addEventListener('error', afterPoster, { once: true }); setTimeout(() => ensure(false), 2500); }
})();
